import {Dialog, Button, Icon, Loading} from '@startlibs/components'
import {getColor,  postFetcher} from '@startlibs/utils'
import React, { useEffect, useState } from 'react'
import _ from 'lodash/fp'

import {useNotificationRef} from '../../components/Notifications'
import styled, { css } from 'styled-components';
import { StudyCard } from './StudyCard';
import { lighten, margin } from 'polished';
import { useErrors, useProvideErrors } from '@startlibs/form'
import { useToggle } from '@startlibs/core'


const InfoBox = styled.div`
  background: ${getColor('gray240')};
  border: 1px solid ${getColor('gray210')};
  border-radius: 6px;
  padding: 1rem;
  margin-bottom: 0.75rem;
  width: 100%;
  color: ${getColor('gray120')};
  ${props => props.dark && css`
    background: ${getColor('gray150')};
    border-color: ${getColor('gray150')};
    color: white;
  `}
  ${props => props.error && css`
    background: ${props => lighten(0.43, props.theme.colors.alert)};
    border-color: ${props => lighten(0.32, props.theme.colors.alert)};
    color: ${getColor('alert')};
  `}
  ${props => props.withIcon && css`
    display: flex;
    align-items: center;
    ${Icon} {
      font-size: 16px;
      margin-right: .5rem;
    }
  `}
  ${props => props.autoSaveNotice && css`
    margin: 0 0 2rem;
  `}
  li {
    list-style-type: disc;
    margin: 0rem 2rem;
    font-size: 13px;
  }
`

function convertToISO8601(dateString) {
  try {
    
    if (typeof dateString !== 'string' || !dateString) {
      throw new Error("Invalid date string");
    }
    
    
    const dateObject = new Date(dateString.replace(' ', 'T') + 'Z');
    if (isNaN(dateObject.getTime())) {
      throw new Error("Invalid date format");
    }
    
    
    const isoDateString = dateObject.toISOString();
    const isoDateStringWithoutMilliseconds = isoDateString.split('.')[0] + 'Z';
    
    return isoDateStringWithoutMilliseconds;
  } catch (error) {
    console.error("Error converting date:", error.message);
    return "";
  }
}

export const DeleteStudyDialog = ({study, setStudy, closeDialog, setInvalidateCache, hasAttachments, hasStudyNotes, hasReports, hasTags, setStudies, setCurrentQuantity}) => {
  
  const [,setNotification] = useNotificationRef()
  const [isLoading, setIsLoading] = useState(true)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const confirmationDialog = useToggle()
  const studyUid = study.study.iuid;
  // const relatedObjects = {
  //   report: false, //hasReports,
  //   studyNotes: false, //hasStudyNotes > 0,
  //   attachments: false, //hasAttachments > 0,
  //   tags:false, // hasTags
  // }
  // const hasRelatedContent = Object.values(relatedObjects).some(value => value === true);

  const [relatedObjects, setRelatedObjects] = useState({
    report: hasReports,
    studyNotes: hasStudyNotes > 0,
    attachments: hasAttachments > 0,
    tags: hasTags
  })

 
  const [hasRelatedContent, setHasRelatedContent] = useState()

  useEffect(() => {
    setHasRelatedContent(Object.values(relatedObjects).some(value => value === true));
  }, [relatedObjects])

  useEffect(() => {
  

    postFetcher('/deletestudyverify.php', {
      studyUID: studyUid,
    })
    .then((response) => {
      setRelatedObjects(relatedObjects => {
        return {
          ...relatedObjects,
          report: response.countReports > 0,
          studyNotes: response.countStudyNotes > 0,
          attachments: response.countAttachments > 0,
          tags: response.countTags > 0
        }
      })
    })
    .catch((error) => {
      console.log(error)
    })
    .finally(() => {
      setIsLoading(false)
    })
      

  }, [])
  
  const [eUtils,errors] = useErrors()
  
  return <Dialog
      title="Delete study"
      closeDialog={closeDialog}
      footer={ () => {
        return <>
          <Button onClick={closeDialog}>Cancel</Button>
          {!hasRelatedContent && <Button type="submit" 
            alert
            // disabled={hasRelatedContent}
            onClick={
              () => {
                confirmationDialog.toggle()
                // if(!hasRelatedContent){
                //   setIsSubmitting(true)
                //   postFetcher('/deletestudy.php', {
                //     studyDescription: study.study.studyDescription || "",
                //     patientID: study.patient.patientID || "",
                //     patientName: study.patient.patientName || "",
                //     studyUID: studyUid
                //   })
                //   .then(() => {
                //     setIsSubmitting(false)
                //     setStudies(studies => studies.filter(study => study.study.iuid !== studyUid))
                //     setInvalidateCache(true)
                //     closeDialog()
                //     setNotification({type:"success",msg:<>Study deleted.</>})
                //   })
                //   .catch((e)=> {
                //     setIsSubmitting(false)
                //     eUtils.setError('delete','Failed to delete study')
                //     setNotification({type:"alert",msg:<>Failed to delete study.</>})
                //   })
                // }
                
              }
            }
            disabled={isLoading}
            isLoading={isSubmitting}>
            Delete
          </Button>}
        </>}
      }
    >
      {isLoading 
        ? <Loading size={32} style={{margin: '60px auto'}} />
        : <>
          <p>This study will be permanently deleted.</p>
          <StudyCard study={study}/>
          {/* <p>Note: This action <b>cannot be undone.</b></p> */}
          {!hasRelatedContent && <p>Previously generated share links will be inactivated. </p>}
          {!hasRelatedContent && <p>
            Please wait at least 48 hours before reuploading this same study.
          </p>}
          {hasRelatedContent && <InfoBox error>
            <p>
              <span>This study can not be deleted because it has the following related content:</span>
            </p>
            <ul>
              {relatedObjects.report && <li>Report</li>}
              {relatedObjects.studyNotes && <li>Study notes</li>}
              {relatedObjects.attachments && <li>Attachments</li>}
              {relatedObjects.tags && <li>Tags</li>}
            </ul>
          </InfoBox>}
          {errors}
        </>
      }
      {confirmationDialog.isOpen && <Dialog
        closeDialog={() => {
          confirmationDialog.toggle
          closeDialog()
        }}
        title="Confirm deletion"
        footer={<>
          <Button onClick={() => {
            confirmationDialog.toggle()
            closeDialog()
          }}>Cancel</Button>
          <Button
            alert
            onClick={() => {
              if(!hasRelatedContent){
                setIsSubmitting(true)
                postFetcher('/deletestudy.php', {
                  studyDescription: study.study.studyDescription || "",
                  patientID: study.patient.patientID || "",
                  patientName: study.patient.patientName || "",
                  studyUID: studyUid,
                  uploadDate: convertToISO8601(study.study.uploadDate)
                })
                .then(() => {
                  setIsSubmitting(false)
                  setStudies(studies => studies.filter(study => study.study.iuid !== studyUid))
                  setInvalidateCache(true)
                  setCurrentQuantity(currentQuantity => currentQuantity - 1)
                  confirmationDialog.toggle()
                  closeDialog()
                  setNotification({type:"success",msg:<>Study deleted.</>})
                })
                .catch((e)=> {
                  // console.log(e)
                  setIsSubmitting(false)
                  confirmationDialog.toggle()
                  if(e && e.length > 0 && e[0].response == false){
                    setRelatedObjects(relatedObjects => {
                      return {
                        ...relatedObjects,
                        report: e[0].statusReport === "Reported" 
                        || e[0].statusReport === "Draft" 
                        || e[0].countReports > 0,
                        studyNotes: e[0].countStudyNotes > 0,
                        attachments: e[0].countAttachments > 0,
                        tags: e[0].countTags > 0
                      }
                    })
                  }
                  eUtils.setError('delete','Failed to delete study')
                  setNotification({type:"alert",msg:<>Failed to delete study.</>})
                })
              }
            }}
            isLoading={isSubmitting}
          >
            Delete
          </Button>
        </>
        }
      >
        <p>Are you sure you want to delete this study?</p>
        <StudyCard study={study}/>
        <p>Note: This action <b>cannot be undone.</b></p>
      </Dialog>}
    </Dialog>
}
